export default "__VITE_ASSET__BJM7OJCi__"